import { useEffect, useState } from 'react';
import { useParams, Link, Routes, Route, useNavigate } from 'react-router-dom';
import QuizEditor from './Editor';
import { FaSearch, FaCheckCircle, FaEllipsisV, FaTimesCircle, FaRocket } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { addQuiz, deleteQuiz, setQuizzes, updateQuiz } from "./reducer";
import * as client from "./client";
import QuizContextMenu from './QuizContextMenu';  // include the QuizContextMenu component

export default function Quizzes() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { cid } = useParams<{ cid: string }>();
    const stateQuizzes = useSelector((state: any) => state.quizzesReducer ? state.quizzesReducer.quizzes : []);
    const curUser = useSelector((state: any) => state.accountReducer.currentUser || {});

    const isStudent = curUser?.role === 'STUDENT';
    const quizzes = stateQuizzes.filter((q: any) => isStudent && !q.published ? null : q);

    const [activeQuizId, setActiveQuizId] = useState<string | null>(null);  // use state to keep track of the active quiz
    // Fetch quizzes
    const fetchQuizzes = async () => {
        const quizzes = await client.findQuizzesForCourse(cid as string);
        dispatch(setQuizzes(quizzes));
    };

    useEffect(() => {
        fetchQuizzes();
    }, [cid]);

    // Create quiz
    const createQuiz = async (quizId: string) => {
        const quiz = {
            title: "New Quiz",
            course: cid,
        };
        dispatch(addQuiz(quiz));
        navigate(`/Kanbas/Courses/${cid}/Quizzes/${quizId}`);
    };

    // Delete quiz
    const handleDeleteQuiz = async (quizId: string) => {
        await client.deleteQuiz(quizId);
        dispatch(deleteQuiz(quizId));
    };

    // Toggle Publish
    const handleTogglePublishQuiz = async (quizId: string) => {
        if(isStudent) {
            // other roles have permission, such as admin,  need to define them by yourself
            window.alert('sorry! do not have access');
            return;
        }
        const quiz = quizzes.find((q: any) => q._id === quizId);
        const resQuiz = await client.updateQuiz({ ...quiz, published: !quiz.published });
        dispatch(updateQuiz(resQuiz));
        // dispatch({ type: 'TOGGLE_PUBLISH', quizId });
    };

    // Handle edit quiz
    const handleEditQuiz = (quizId: string) => {
        if(isStudent) {
            navigate(`/quiz-detail-preview/${quizId}`);
            return;
        }
        navigate(`/Kanbas/Courses/${cid}/Quizzes/${quizId}`);
    };

    return (
        <div style={{ width: '100%', margin: '0', fontFamily: 'Arial, sans-serif' }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 20px',
                borderBottom: '1px solid #ddd',
                backgroundColor: '#f9f9f9',
                marginBottom: '10px'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                    <FaSearch style={{ marginRight: '10px' }} />
                    <input
                        placeholder="Search for Quiz"
                        style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px'
                        }}
                    />
                </div>
                {!isStudent && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {!quizzes.length && (
                            <div
                                style={{
                                    color: 'red',
                                    fontSize: '12px',
                                    backgroundColor: 'yellow',
                                    position: 'absolute',
                                    top: '40px',
                                    height: '30px',
                                    borderRadius: '10px',
                                    padding: '5px'
                                }}
                            >
                                please get new Quiz
                            </div>
                        )}
                        <button
                            onClick={() => createQuiz('new')}
                            style={{
                                marginLeft: '10px',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                padding: '8px 16px',
                                borderRadius: '4px',
                                border: 'none',
                                cursor: 'pointer'
                            }}
                        >
                            + Quiz
                        </button>
                        <button
                            style={{
                                marginLeft: '10px',
                                backgroundColor: '#f8f9fa',
                                padding: '8px 16px',
                                borderRadius: '4px',
                                border: '1px solid #ddd',
                                cursor: 'pointer'
                            }}
                        >
                            <FaEllipsisV />
                        </button>
                    </div>
                )}
            </div>

            <div style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#f1f1f1',
                padding: '10px 20px',
                border: '1px solid #ddd',
                fontWeight: 'bold',
                marginBottom: '10px',
                color: '#333',
                borderLeft: '5px solid #3E9F41'
            }}>
                <span style={{ marginRight: '8px' }}>⯆</span>
                Assignment Quizzes
            </div>

            <ul style={{ listStyleType: 'none', padding: '0' }}>
                {quizzes.filter((q: any) => q.course === cid).map((quiz: any) => (
                    // isStudent && !q.published ? null :
                    <li
                        key={quiz._id}
                        style={{
                            padding: '15px',
                            border: '1px solid #ddd',
                            borderRadius: '5px',
                            backgroundColor: '#fff',
                            marginBottom: '10px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <FaRocket style={{ color: '#3E9F41', marginRight: '10px' }} />
                                {quiz.published ? (
                                    <FaCheckCircle
                                        onClick={() => handleTogglePublishQuiz(quiz._id)}
                                        style={{ color: '#3E9F41', marginRight: '10px', cursor: 'pointer' }}
                                    />
                                ) : (
                                    <FaTimesCircle
                                        onClick={() => handleTogglePublishQuiz(quiz._id)}
                                        style={{ color: '#d9534f', marginRight: '10px', cursor: 'pointer' }}
                                    />
                                )}
                                <div
                                    onClick={() => handleEditQuiz(quiz._id)}
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#333',
                                        textDecoration: 'none',
                                        marginRight: 'auto',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {quiz.title}
                                </div>
                                {!isStudent && (
                                    <FaEllipsisV
                                        style={{ marginLeft: '10px', cursor: 'pointer', color: '#888', fontSize: '18px' }}
                                        onClick={() => setActiveQuizId(activeQuizId === quiz._id ? null : quiz._id)}
                                    />
                                )}
                                {activeQuizId === quiz._id && (
                                    <QuizContextMenu
                                        onEdit={() => handleEditQuiz(quiz._id)}
                                        onDelete={() => handleDeleteQuiz(quiz._id)}
                                        onTogglePublish={() => handleTogglePublishQuiz(quiz._id)}
                                        isPublished={quiz.published}
                                    />
                                )}
                            </div>

                            <div style={{ fontSize: '14px', color: '#555', marginTop: '5px', width: '100%', paddingLeft: '28px' }}>
                                {new Date(quiz.availableDate) > new Date()
                                ? `Not available until ${new Date(quiz.availableDate).toLocaleDateString()}`
                                : new Date(quiz.untilDate) > new Date() && new Date() > new Date(quiz.availableDate)
                                ? <strong>Available</strong>
                                :  <strong>Closed</strong>}
                                | <strong>Due</strong> {new Date(quiz.dueDate).toLocaleDateString()} at 11:59pm
                                | {quiz.points} pts
                                | {quiz.questions?.length || 0} Questions
                            </div>
                        </div>
                    </li>
                ))}
            </ul>

            <Routes>
                <Route path=":id" element={<QuizEditor />} />
                <Route path="new" element={<QuizEditor />} />
            </Routes>
        </div>
    );
}
